export const RSN_DEFAULT_PACKAGES = [
  "ATT_TV_CHOICE",
  "ATT_TV_PREMIER",
  "ATT_TV_ULTIMATE"
];

export const LOCAL_DEFAULT_PACKAGES = [
  "ATT_TV_ENTERTAINMENT",
  "ATT_TV_CHOICE",
  "ATT_TV_ULTIMATE",
  "ATT_TV_PREMIER",
  "ATT_TV_OPTIMO_MAS"
];

export const FALLBACK_CHNL_ICON_URL = 'https://www.directv.com/dtvassets/global/channel-icons/m-n/Channel_Icon_No-Logo.svg';
